import { render, staticRenderFns } from "./m-surplus-size-err-modal.vue?vue&type=template&id=523bb29e&"
import script from "./m-surplus-size-err-modal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-surplus-size-err-modal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports